import { useTranslation } from "react-i18next";
import { useLanguageContext } from "@/contexts/LanguageContext";

/**
 * Hook principal pour la gestion de la langue dans Hirafi.
 * Expose locale, isRTL, setLocale et t (fonction de traduction).
 */
export function useLanguage(ns?: string | string[]) {
  const { locale, setLocale, isRTL } = useLanguageContext();
  const { t } = useTranslation(ns);
  return { locale, setLocale, isRTL, t };
}
